import React, { useState, useRef } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import cx from "classnames";

const StatusMessage = (props) => {
  const joining_data = _.get(props, "paramsReducer.gameObj.joining");
  const game_state = _.get(props, "gameReducer.roomObj.game_state");
  if (props.hero) {
    const hero_status = _.get(game_state, "hero_status");
    const hero_good = _.get(joining_data, "hero_good", "Looks Good!");
    const get_bad_status = (slidekick_status) => {
      if (hero_status == "Invalid Link") {
        return _.get(
          joining_data,
          "hero_badlink",
          "Not able to open the slides, please check the link."
        );
      } else if (hero_status === "Invalid Slides") {
        return _.get(
          joining_data,
          "slidekick_badslides",
          "Something went wrong when opening the slides."
        );
      } else if (hero_status === "Wrong Size") {
        return _.get(
          joining_data,
          "hero_badlink",
          "The number of slides does not match the Hero."
        );
      }
    };
    return (
      <>
        {hero_status == "Good" ? (
          <p className="green-alert">
            <i className="fa fa-check-circle"></i>
            {hero_good}
          </p>
        ) : (
          <p className="red-alert">
            <i className="fa fa-info-circle"></i>
            {get_bad_status(hero_status)}
          </p>
        )}
      </>
    );
  } else if (props.slidekick) {
    const slidekick_status = _.get(game_state, "slidekick_status");
    const slidekick_good = _.get(joining_data, "slidekick_good", "Looks Good!");
    const get_bad_status = (slidekick_status) => {
      if (slidekick_status == "Invalid Link") {
        return _.get(
          joining_data,
          "slidekick_badlink",
          "Not able to open the slides, please check the link."
        );
      } else if (slidekick_status === "Invalid Slides") {
        return _.get(
          joining_data,
          "slidekick_badslides",
          "Something went wrong when opening the slides."
        );
      } else if (slidekick_status === "Wrong Size") {
        return _.get(
          joining_data,
          "slidekick_badsize",
          "The number of slides does not match the Hero."
        );
      }
    };
    return (
      <>
        {slidekick_status == "Good" ? (
          <p className="green-alert">
            <i className="fa fa-check-circle"></i>
            {slidekick_good}
          </p>
        ) : (
          <p className="red-alert">
            <i className="fa fa-info-circle"></i>
            {get_bad_status(slidekick_status)}
          </p>
        )}
      </>
    );
  }
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
});
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(StatusMessage);
